import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { useGetCoachesQuery } from '@backrs_ui/grow-ui/src/redux/coaches/coaches.api';
import { useGetDeepDivesQuery } from '@backrs_ui/grow-ui/src/redux/deepDive/deepDive.api';
import {
  selectIsFeatureFlagEnabled,
  FEATURE_FLAGS,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { CoachesPage } from './CoachesPage';
import { useAgentContext } from './CoachesPageContainer.agentContext';

export const CoachesPageContainer = () => {
  const flagValues = useAppSelector((state) => state.featureFlags.flagValues);
  const isCoachingEnabled = useAppSelector(selectIsFeatureFlagEnabled(FEATURE_FLAGS.COACHING));

  const {
    data: coaches,
    isLoading: isLoadingCoaches,
    isError: isCoachesError,
  } = useGetCoachesQuery(undefined);
  const {
    data: deepDives,
    isLoading: isLoadingDeepDives,
    isError: isDeepDivesError,
  } = useGetDeepDivesQuery(undefined);

  useAgentContext(coaches);

  // Create a map of deep dive ID to category name
  const deepDiveCategoryMap = useMemo(() => {
    if (!deepDives) return new Map<number, string>();

    const map = new Map<number, string>();

    deepDives.forEach((dd) => {
      if (dd.category?.name) {
        map.set(dd.id, dd.category.name);
      }
    });

    return map;
  }, [deepDives]);

  if (!(FEATURE_FLAGS.COACHING in flagValues) || isLoadingCoaches || isLoadingDeepDives) {
    return <FullScreenLoading />;
  }

  if (!isCoachingEnabled || isCoachesError || !coaches || isDeepDivesError) {
    return <Navigate to={APP_ROUTE.HOME} replace />;
  }

  return <CoachesPage coaches={coaches} deepDiveCategoryMap={deepDiveCategoryMap} />;
};
